export default __webpack_public_path__ + "static/media/seller.e4a13b5e.png";